import { render, staticRenderFns } from "./TranslateModal.vue?vue&type=template&id=4501e7cd&scoped=true"
import script from "./TranslateModal.vue?vue&type=script&lang=js"
export * from "./TranslateModal.vue?vue&type=script&lang=js"
import style0 from "./TranslateModal.vue?vue&type=style&index=0&id=4501e7cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4501e7cd",
  null
  
)

export default component.exports